export const Views = {
    LOGIN: "login",
    MAIN: "main",
    SPLASH : "splash"
}